import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import LineFloatingButton from '../../components/feature/LineFloatingButton';
import EnrollmentHeroSection from './components/EnrollmentHeroSection';
import EnrollmentFlowSection from './components/EnrollmentFlowSection';
import EnrollmentCTASection from './components/EnrollmentCTASection';
import SeoHead from '../../components/feature/SeoHead';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const enrollmentJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    url: `${SITE_URL}/enrollment`,
    name: '東京シニア婚活 入会の流れ | 縁結び 和はは',
    description: '東京のシニア婚活相談所「縁結び和はは」への入会の流れ。婚活東京シニア専門で50代・60代・70代の方が安心して婚活を始められるステップをご案内。',
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'ホーム', item: SITE_URL },
        { '@type': 'ListItem', position: 2, name: '入会の流れ', item: `${SITE_URL}/enrollment` },
      ],
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'HowTo',
    name: '縁結び和はは 入会の流れ',
    description: '東京シニア婚活相談所の3ステップ入会プロセス。ご予約・無料相談・ご入会まで丁寧にサポート。',
    step: [
      {
        '@type': 'HowToStep',
        position: 1,
        name: 'ご予約',
        text: 'お電話・ホームページ・LINE公式アカウントよりご都合に合わせてご予約ください。小さなご不安やご質問でもお気軽にどうぞ。',
      },
      {
        '@type': 'HowToStep',
        position: 2,
        name: '無料相談',
        text: '約60分の無料相談で、ご状況やご希望をお伺いします。都内・近郊は対面、遠方の方はオンライン（ZOOM）でも対応。無理な勧誘は一切ございません。',
      },
      {
        '@type': 'HowToStep',
        position: 3,
        name: 'ご入会',
        text: 'ご納得いただいたうえで入会手続き。独身証明書・卒業証明書・身分証明書など必要書類をご準備いただき、お見合い用プロフィールを一緒に作成します。',
      },
    ],
  },
];

export default function EnrollmentPage() {
  return (
    <>
      <SeoHead
        title="東京シニア婚活相談所入会の流れ | 縁結び 和はは"
        description="東京のシニア婚活相談所「縁結び和はは」への入会の流れ。婚活東京シニア専門で50代・60代・70代の婚活を無料相談から入会・お見合い・成婚まで丁寧にご案内。東京シニア婚活を安心して始められます。"
        keywords="東京 シニア 婚活, 婚活相談所 入会 東京, 婚活入会手続き, シニア婚活入会, 婚活無料相談東京, 60代婚活はじめ方"
        path="/enrollment"
        jsonLd={enrollmentJsonLd}
      />
      <Navbar />
      <main>
        <EnrollmentHeroSection />
        <EnrollmentFlowSection />
        <EnrollmentCTASection />
      </main>
      <Footer />
      <LineFloatingButton />
    </>
  );
}
